
import React from 'react'
import { getAllToken, clearBSRSToken, clearToken } from 'Lib'
import CookieAmenityServiceManager from '../business/CookieAmenityServiceManager'
import { cookiesKey } from '../constant'

class AmenityServiceRoutePermission extends React.Component {
    constructor(props) {
        super(props)
        const { access_token } = getAllToken()
        this.bCookie = new CookieAmenityServiceManager()
        let data = this.bCookie.getDataCookies()
        if (!!access_token) {
            clearBSRSToken()
            clearToken()
            if (!!data) {
                this.bCookie.setDataCookies(data)
            }
        }
    }

    isAuthenticated = () => {
        const token = this.bCookie.getData(cookiesKey.TOKEN)
        // , tokenExpired = this.bCookie.getData(cookiesKey.REFRESH_TOKEN_EXPIRES_DATE)

        return !!token
        // && moment().isBefore(moment(tokenExpired))
    }

    getPathCurrent = () => {
        try {
            const { location } = this.props
            let pathCurrent = "/"
            if (!!location && !!location.pathname && typeof location.pathname === 'string') {
                pathCurrent = location.pathname
            }
            return pathCurrent
        } catch (error) {
            return "/"
        }
    }

    getComponentRoute = () => {
        try {
            const { component, path } = this.props

            let obj = {
                Component: null,
                path: path,
                props: null
            }

            let propsRouter = {}
            if (!!component) {
                obj.Component = component
            }
            if ("exact" in this.props) {
                propsRouter.exact = true
            }
            obj.props = propsRouter
            return obj
        } catch (error) {
            return {
                Component: null,
                path: ",",
                props: null
            }
        }
    }
}

AmenityServiceRoutePermission.defaultProps = {
    component: null
}

export default AmenityServiceRoutePermission


// WEBPACK FOOTER //
// ./src/policy/AmenityServiceRoutePermission.js